import { render, staticRenderFns } from "./LoginPageWrap.vue?vue&type=template&id=67bdb2f6&scoped=true&"
import script from "./LoginPageWrap.vue?vue&type=script&lang=js&"
export * from "./LoginPageWrap.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageWrap.vue?vue&type=style&index=0&id=67bdb2f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdb2f6",
  null
  
)

export default component.exports